import { AbstractControl } from '@angular/forms';

export function ValidationsUrl(control: AbstractControl): {} | null {
    let 
        string = control.value ? control.value : '',
        res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);

    if (!string) return null
    else if (res && string) return null

    return {urlNotValid: 'الرابط غير صالح'}
    

}